import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Paths } from "./Constants/paths";
import AuthForm from "./Components/auth";
import { SnackBarWrapper } from "./Components/snackBar/snackBarWrapper";
import AppWrapper from "./Components/appWrapper";
import Dashboard from "./Pages/dashboard";
import Parents from "./Pages/parents";
import { ParentsListPage } from "./Pages/parents/parentsListPage";
import { StudentAdmissionPage } from "./Pages/students/studentsAdmissionPage";
import { StudentListPage } from "./Pages/students/StudentListPage";
import { StudentDetailPage } from "./Pages/students/StudentDetailPage";
import { ParentDetailsPage } from "./Pages/parents/ParentDetailsPage";
import { RegisterTeachers } from "./Pages/teachers/RegisterTeachers";
import { TeachersList } from "./Pages/teachers/TeachersList";
import { TeacherDetailsPage } from "./Pages/teachers/TeacherDetailsPage";
import { Subjects } from "./Pages/subjects";
import { Branches } from "./Pages/branches";
import { Blocks } from "./Pages/blocks";
import { Classes } from "./Pages/classes";
import { Transport } from "./Pages/transport";
import { Notifications } from "./Pages/notifications";
import { AuthenticationRoute } from "./Components/auth/AuthenticationRoute";
import { Results } from "./Pages/results";
import { ResultDetailsPage } from "./Pages/results/ResultDetailsPage";
import { SchoolPrices } from "./Pages/schoolPrices/SchoolPrices";

function App() {
  return (
    <Router>
      <SnackBarWrapper />
      <Routes>
        <Route path={Paths.Login} element={<AuthForm />}></Route>
        <Route element={<AppWrapper />}>
          <Route path={Paths.Dashboard} element={<Dashboard />} />
          <Route element={<AuthenticationRoute />}>
            <Route path={Paths.StudentList} element={<StudentListPage />} />

            <Route path={Paths.StudentList} element={<StudentListPage />} />

            <Route
              path={Paths.StudentDetails}
              element={<StudentDetailPage />}
            />

            <Route path={Paths.RegisterParent} element={<Parents />} />

            <Route path={Paths.ParentsDetail} element={<ParentDetailsPage />} />

            <Route path={Paths.ParentsList} element={<ParentsListPage />} />

            <Route
              path={Paths.RegisterTeachers}
              element={<RegisterTeachers />}
            />

            <Route path={Paths.TeachersList} element={<TeachersList />} />

            <Route
              path={Paths.TeacherDetail}
              element={<TeacherDetailsPage />}
            />

            <Route
              path={Paths.StudentAdmission}
              element={<StudentAdmissionPage />}
            />

            <Route path={Paths.Subject} element={<Subjects />} />

            <Route path={Paths.Branch} element={<Branches />} />

            <Route path={Paths.Block} element={<Blocks />} />

            <Route path={Paths.Class} element={<Classes />} />

            <Route path={Paths.Transport} element={<Transport />} />

            <Route path={Paths.Notification} element={<Notifications />} />

            <Route path={Paths.AddResult} element={<Results />} />

            <Route path={Paths.ResultDetails} element={<ResultDetailsPage />} />

            <Route path={Paths.SchoolPrices} element={<SchoolPrices />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
